import { createAction } from "@reduxjs/toolkit";
import {MapFocusPoint, MapState, MapFilter, MapOpsModeFilter} from "@ots-frontend/ots-ui";

export const setMapState = createAction<MapState>("map/setMapState");
export const setMapFocusPoint = createAction<MapFocusPoint | undefined>("map/setMapFocusPoint");
export const setMapFilter = createAction<MapFilter>("map/setMapFilter")
export const setMapFilterEntity = createAction<"VEHICLE" | "TRAILER" | "PERSON">("map/setMapFilterEntity")
export const setMapOpsMode = createAction<boolean>("map/setMapOpsMode")
export const setMapOpsModeFilter = createAction<MapOpsModeFilter>("map/setMapOpsModeFilter")
